#import "@/components/common/StoryPreviewFragment.gql"

fragment FullWidthBarWithCtaFragment on fullWidthBarWithCta_Entry {
  typeHandle
  heading
  positionRight
  editorsPick
  story {
    ...StoryPreviewFragment
  }
  image {
    url
    title
  }
  alt
}
